import { Skeleton } from "@/components/ui/skeleton";

const PaymentSectionSkeleton = () => {
  return (
    <>
      <div className="flex flex-col gap-y-4">
        <Skeleton className="h-8" />
        <Skeleton className="h-8" />
      </div>
      <div className="border-b dark:border-brand-gray-600 mt-3 mb-2" />
      <div className="flex flex-col gap-y-4">
        <Skeleton className="h-6" />
        <Skeleton className="h-6" />
        <div className="flex  flex-col gap-1 -mt-1">
          <Skeleton className="h-4" />
          <Skeleton className="h-4" />
        </div>
      </div>
    </>
  );
};

export default PaymentSectionSkeleton;
